import {type JSX} from 'react'
import type {IContentItem} from '@kontent-ai/delivery-sdk'
import type {ExtendedBlock, Tersed} from '@/services/kontent-ai/types'
import type {
	PetTraitContentItem,
	PetTraitGroupContentItem,
} from '@/products/pet-name-finder/models'
import type {TraitsByType} from './pet-trait-card'
import {PetTraitCardBlock} from './pet-trait-card'
import {CardWrapper} from './card-wrapper'

interface PetNameFormProps {
	traitGroup: Tersed<PetTraitGroupContentItem>
	selectedTraitsByGroup: TraitsByType
	toggleTrait: (
		traitName: Tersed<PetTraitContentItem>,
		groupTitle: string
	) => void
}

export const PetTraitGroupCardBlock: ExtendedBlock<
	IContentItem,
	PetNameFormProps
> = ({
	traitGroup,
	selectedTraitsByGroup,
	toggleTrait,
	...context
}): JSX.Element => {
	const isTwoCol = traitGroup.elements.traitBlocks.length === 2
	return (
		<CardWrapper title={traitGroup.elements.displayTitle}>
			<ul className="flex max-w-[515px] flex-wrap justify-center">
				{traitGroup.elements.traitBlocks.map((trait) => {
					const selectedTraits =
						selectedTraitsByGroup[traitGroup.elements.displayTitle]

					const selectedTraitDisplayName =
						selectedTraits?.elements.displayName

					const isActive =
						selectedTraitDisplayName === trait.elements.displayName
					const isUnselected =
						selectedTraitDisplayName !== trait.elements.displayName

					return (
						<li
							className={`mb-5 flex justify-center px-4 ${isTwoCol ? 'basis-1/2' : 'basis-1/2 md:basis-1/3'}`}
							key={trait.elements.displayName}
						>
							<PetTraitCardBlock
								{...context}
								block={trait}
								isActive={isActive}
								key={trait.elements.displayName}
								onClick={(
									selectedTrait: Tersed<PetTraitContentItem>
								) => {
									toggleTrait(
										selectedTrait,
										traitGroup.elements.displayTitle
									)
								}}
								unselected={Boolean(
									selectedTraitDisplayName && isUnselected
								)}
							/>
						</li>
					)
				})}
			</ul>
		</CardWrapper>
	)
}
